import {requestCommon} from '../libs/axios'


export const lawyerRechargeServicerList = (params) => requestCommon.post('/paralegal/v2/lawyerRechargeService/list', params) // 律师充值服务列表v2

export const lawyerRechargeServicerList2 = (params) => requestCommon.post('/paralegal/v2/lawyerRechargeService/listAndBalance', params) // 律师充值服务列表v2

export const walletBalance = (params) => requestCommon.post('/paralegal/v2/wallet/balance', params) // v2律师余额查询

export const orderLawyerPay = (params) => requestCommon.post('/order/v2/orderLawyer/pay', params) // 支付v2

export const orderLawyerCreateOrder = (params) => requestCommon.post('/order/v2/orderLawyer/createOrder', params) // 用户订单创建v2

export const orderLawyerQueryOrderStatus = (params) => requestCommon.post('/order/v2/orderLawyer/queryOrderStatus', params) // v2律师订单状态查询

export const getVipInfoList = (params) => requestCommon.post('/paralegal/vip/getVipInfoList', params) // 获取可用会员列表
